import React, { useState, useRef, useEffect } from "react";
import "./index.scss";
import { Avatar, Box, Button, getColor, Icons, Tooltip, Typography } from "fds";
import { useNavigate } from "react-router-dom";
import { WorkspaceDTO } from "../../redux/store/workspace";
import WorkspaceHomeIcon from "./WorkspaceHomeIcon";
import classNames from "classnames";
import { setWorkspaceName, setWorkspaceCode } from "../../shared/utils/auth";
interface WorkgroupCardProps {
  item: WorkspaceDTO;
  size?: "32" | "20" | "24" | "40" | "48";
}
export const pickColor = (id: string): any => {
  const colors = [
    "green",
    "deepGreen",
    "cyan",
    "deep_cyan",
    "blue",
    "deep_blue",
    "purple",
    "deep_purple",
    "navy",
  ];
  return colors[(id.charCodeAt(0) + id.charCodeAt(id.length - 1)) % 9];
};

const WorkspaceAvatar: React.FC<WorkgroupCardProps> = ({ item, size }) => {
  const navigate = useNavigate();
  const isDisabled =
    item.tenancyStatus === "PAUSE" || item?.allowIpAccess === false;
  const isMainWorkspace = item.dsdCode == "MTECOCOMMON00001";
  const isClicked = decodeURI(window.location.href).includes(item.alias);
  const iSMyDefaultTenancy = item.myDefaultTenancy;
  return (
    <Tooltip message={item.tenancyName} classes="mg mb-8">
      <Avatar
        name={item.tenancyName}
        uniqueCode={item.alias}
        color={pickColor(item.alias) ?? "green"}
        shape={"workgroup"}
        size={size ?? "32"}
        style={{ borderRadius: "50%", position: "relative" }}
        opacity={isDisabled ? "20%" : "100%"}
        classes={classNames("workspaceAvatar", {
          clicked: isClicked,
          isDefault: iSMyDefaultTenancy,
        })}
        onClickAvatar={(e) => {
          setWorkspaceName(item.alias);
          setWorkspaceCode(item.dsdCode ?? "MTECOCOMMON00001");
          navigate(`${process.env.PUBLIC_URL}/${item.alias}/home`);
        }}
        subIcon={
          isMainWorkspace ? (
            <WorkspaceHomeIcon
              style={{
                position: "absolute",
                bottom: "-3px",
                insetInlineEnd: "-5px",
              }}
            />
          ) : undefined
        }
      />
    </Tooltip>
  );
};
export default WorkspaceAvatar;
